import { useContext } from 'react';
import { theme as antdTheme } from 'antd';

import { ThemeContext } from '@/contexts/01-Unauthenticated/theme';
import { getThemeSelectionOptions, normalizeThemeSelectionName } from '@/hooks/useThemeConfig';

export const useAntDesignTheme = () => {
    const context = useContext(ThemeContext);

    if (!context) {
        throw new Error('useAntDesignTheme must be used within ThemeProvider.');
    }

    const {
        themeName: storedThemeName,
        resolvedThemeName,
        setTheme,
        themes,
        registerTheme,
        setWorkspaceThemeConfiguration,
        workspaceThemeConfiguration,
    } = context;
    const themeName = normalizeThemeSelectionName(storedThemeName);
    const themeOptions = getThemeSelectionOptions(workspaceThemeConfiguration);

    const { token } = antdTheme.useToken();

    // !TODO: make this more elegantly implemented
    const chartLineItemColors = [
        {
            name: 'blue',
            fill: token.blue1,
            stroke: token.blue6,
        },
        {
            name: 'green',
            fill: token.green1,
            stroke: token.green6,
        },
        {
            name: 'gold',
            fill: token.gold1,
            stroke: token.gold6,
        },
        {
            name: 'cyan',
            fill: token.cyan1,
            stroke: token.cyan6,
        },
        {
            name: 'magenta',
            fill: token.magenta1,
            stroke: token.magenta6,
        },
    ];
    const chartComparisonLineItemColors = [
        {
            name: 'purple',
            fill: token.purple1,
            stroke: token.purple6,
        },
        {
            name: 'volcano',
            fill: token.volcano1,
            stroke: token.volcano6,
        },
        {
            name: 'geekblue',
            fill: token.geekblue1,
            stroke: token.geekblue6,
        },
        {
            name: 'lime',
            fill: token.lime1,
            stroke: token.lime6,
        },
        {
            name: 'orange',
            fill: token.orange1,
            stroke: token.orange6,
        },
    ];
    const chartComparisonLineItemColorsSecondary = [
        { name: 'red', fill: token.red1, stroke: token.red6 },
        { name: 'orange', fill: token.orange1, stroke: token.orange6 },
        { name: 'purple', fill: token.purple1, stroke: token.purple6 },
        { name: 'geekblue', fill: token.geekblue1, stroke: token.geekblue6 },
        { name: 'lime', fill: token.lime1, stroke: token.lime6 },
    ];
    const chartComparisonLineItemColorsTertiary = [
        { name: 'magenta', fill: token.magenta1, stroke: token.magenta6 },
        { name: 'volcano', fill: token.volcano1, stroke: token.volcano6 },
        { name: 'cyan', fill: token.cyan1, stroke: token.cyan6 },
        { name: 'green', fill: token.green1, stroke: token.green6 },
        { name: 'gold', fill: token.gold1, stroke: token.gold6 },
    ];
    const chartColorPalettes = [
        chartLineItemColors,
        chartComparisonLineItemColors,
        chartComparisonLineItemColorsSecondary,
        chartComparisonLineItemColorsTertiary,
    ];

    return {
        token,
        themeName,
        resolvedThemeName,
        setTheme,
        registerTheme,
        setWorkspaceThemeConfiguration,
        themes,
        workspaceThemeConfiguration,
        themeOptions,
        available: themeOptions.map(({ name }) => name),
        chartLineItemColors,
        chartColorPalettes,
    };
};
